import { Map, fromJS } from 'immutable';

export function request(state, { marketId, data }) {
    return state.set(
        'add-rule4',
        (state.get('add-rule4') || Map())
            .set(marketId, Map({
                rule4: fromJS(data),
                state: 'IN_PROGRESS'
            }))
    );
}

export function error(state, { marketId, errors }) {
    return state.set(
        'add-rule4',
        (state.get('add-rule4') || Map())
            .set(marketId, Map({
                rule4: state.getIn([ 'add-rule4', marketId, 'rule4' ]),
                state: 'ERROR',
                errors: fromJS(errors)
            }))
    );
}

export function finish(state, { marketId, market }) {
    return state
        .set(
            'add-rule4',
            (state.get('add-rule4') || Map())
                .set(marketId, Map({
                    rule4: state.getIn([ 'add-rule4', marketId, 'rule4' ]),
                    state: 'FINISHED'
                }))
        )
        .setIn([ 'items', market.id ], fromJS(market));
}
